import { combineReducers } from '@reduxjs/toolkit';

import { bulkUpdateTasksSlice } from './bulkUpdateTasks';
import { manageTasksSlice } from './manageTasksPage';
import { secondaryFilterSlice } from './secondaryFilter';
import { selectTaskAttributesModalSlice } from './selectTaskAttributesModal';

export const manageTasksReducers = combineReducers({
  secondaryFilter: secondaryFilterSlice.reducer,
  manageTasks: manageTasksSlice.reducer,
  selectTaskAttributesModal: selectTaskAttributesModalSlice.reducer,
  bulkUpdateTasks: bulkUpdateTasksSlice.reducer,
});
